import * as jwt from 'jsonwebtoken';
import * as Sentry from '@sentry/browser';
/**
 * Extract scopes from a JWT token scp field.
 */ export var getScopesFromToken = function getScopesFromToken(token) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'getScopesFromToken';
    if (!token) return [];
    try {
        var _decoded_scp_split, _decoded_scp;
        var decoded = jwt.decode(token);
        return (decoded === null || decoded === void 0 ? void 0 : (_decoded_scp = decoded.scp) === null || _decoded_scp === void 0 ? void 0 : (_decoded_scp_split = _decoded_scp.split) === null || _decoded_scp_split === void 0 ? void 0 : _decoded_scp_split.call(_decoded_scp, ' ')) || [];
    } catch (error) {
        Sentry.captureException(error, {
            tags: {
                context: context
            }
        });
        return [];
    }
};
/**
 * Check all required scopes are in the provided scopes array.
 */ export var hasRequiredScopes = function hasRequiredScopes(tokenScopes, requiredScopes) {
    if (!tokenScopes || tokenScopes.length === 0) return false;
    var scopeSet = new Set(tokenScopes);
    return requiredScopes.every(function(scope) {
        return scopeSet.has(scope);
    });
};
